import React from "react";
import PlayerHeader from "../../../../../../components/Player/Header/PlayerHeader";
import { useUrl } from "../../../../../../hooks/usePage";
import { Pagetype } from "../../../../../../interfaces/Config";
import { WorkModeType } from "@evidenceb/athena-common/interfaces/Workmode";
import { InfoPanelContent } from "./InfoPanel";
import { useResourceSeries } from "../../../../../../components/Player/ResourceSeries/Contexts";
import { getPlaylist } from "../playlistResourceSeriesReducer.utils";
import { PlaylistResourceSeriesRecord } from "../playlistResourceSeriesReducer";

const Header = () => {
    const playlistURL = useUrl(Pagetype.WORKMODE_PLAYLIST);
    const resourceSeries = useResourceSeries<
        PlaylistResourceSeriesRecord,
        unknown
    >();
    const playlist = getPlaylist(resourceSeries);

    return (
        <PlayerHeader
            title={playlist.name}
            backTo={playlistURL}
            mode={WorkModeType.Playlist}
            infoPanelContent={<InfoPanelContent />}
        />
    );
};
export default Header;
